import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants"
import { environment } from "src/environments/environment"

export const LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK']
export const SEAMLESS_RAINFALL_LAYER_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        'State Boundary': {
            source: 'INDIA',
            displayName: 'State',
            name: 'State Boundary',
            visible: true,
            // hasLegend: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
            layer_name: 'State Boundary',
            layeroptions_pane: 'depth',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'RAINFALL_LEGEND',
            layeroptions_protocol: 'WFS'
        },
        'State Boundaries': {
            source: 'INDIA',
            displayName: 'State Boundaries',
            name: 'State Boundaries',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
            layer_name: 'State Boundaries',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
            type: LAYER_TYPES.GEOJSON_LAYER,
            cql_filter_value: 'UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_protocol: 'WFS'
        },
        'District Boundaries': {
            source: 'INDIA',
            displayName: 'District Boundaries',
            name: 'District Boundaries',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
            layer_name: 'District Boundaries',
            layeroptions_pane: 'max',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
            type: LAYER_TYPES.GEOJSON_LAYER,
            cql_filter_value: 'UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_protocol: 'WFS'
        },
        'District Boundary': {
            source: 'INDIA',
            displayName: 'District',
            name: 'District Boundary',
            visible: true,
            // hasLegend: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
            layer_name: 'District Boundary',
            layeroptions_pane: 'district',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'RAINFALL_LEGEND',
            layeroptions_protocol: 'WFS'
        },
        'Block Boundary': {
            source: 'INDIA',
            displayName: 'Block',
            name: 'Block Boundary',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
            layer_name: 'Block Boundary',
            layeroptions_pane: 'state',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'RAINFALL_LEGEND',
            layeroptions_protocol: 'WFS'
        },
        'State Boundary Labels': {
            source: 'INDIA',
            displayName: 'State',
            name: 'State Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
            layer_name: 'State Boundary',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES',
            crs: 'EPSG4326',
        },
        'District Boundary Labels': {
            source: 'INDIA',
            displayName: 'District Boundary Labels',
            name: 'District Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
            layer_name: 'District Boundary Labels',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'Labels',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'State_UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
        },
        'Block Boundary Labels': {
            source: 'INDIA',
            displayName: 'Block Boundary Labels',
            name: 'Block Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
            layer_name: 'Block Boundary Labels',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'Labels',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'Dist_UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
        },
    }
}

export const SEAMLESS_RAINFALL_LEGEND_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        RAINFALL_LEGEND: {
            colorValues: [
                {
                    backgroundColor: '#d3d8dc',
                    textColor: '#000000',
                    text: 'no rainfall'
                },
                {
                    backgroundColor: "#e6eeff",
                    textColor: '#000000',
                    text: '0-0.5'
                },
                {
                    backgroundColor: "#80aaff",
                    textColor: '#000000',
                    text: '0.5-2.5'
                },
                {
                    backgroundColor: "#3377ff",
                    textColor: '#000000',
                    text: '2.5-5.0'
                },
                {
                    backgroundColor: "#003cb3",
                    textColor: '#000000',
                    text: '5.0-10.0'
                },
                {
                    backgroundColor: "#002266",
                    textColor: '#ffffff',
                    text: '10.0-20.0'
                },
                {
                    backgroundColor: "#ff80b3",
                    textColor: '#000000',
                    text: '20.0-30.0'
                },
                {
                    backgroundColor: "#ff0066",
                    textColor: '#000000',
                    text: '30.0-40.0'
                },
                {
                    backgroundColor: "#cc0000",
                    textColor: '#000000',
                    text: '40.0-50.0'
                },
                {
                    backgroundColor: "#660000",
                    textColor: '#ffffff',
                    text: '50.0-75.0'
                },
                {
                    backgroundColor: "#ffcccc",
                    textColor: '#000000',
                    text: '75.0-100'
                }
            ],
            Units: 'Rainfall (mm/hr)',
        }
    }
}

export const SeamlessRainfallMapConstants: any = {
    PrimarySourceType: 'IMD_SHORT_RANGE',
    SecondarySourceType: 'IMD_LONG_RANGE',

    HeatMapUrl: 'weatherForecast/getHeatMapData/',

    API_MAPPING : {
        GET_LAST_N_DAY_HMP : 'rf/getHeatMapsFromIMD/days/',
        GET_HOURLY_HMP : 'rf/getHeatMapForHourlyRainfallData/',
        GET_NOWCAST_MIN_HMP : 'nowcast/getHeatMapData/',
        GET_FORECAST_7DAYS : 'weatherForecast/getHeatMapData/',
        GET_CTT_RADAR_DATA_HMP : 'nowcast/modelHeatMapData'
    },
    MILLIS_IN_1HOUR: 3600000,
    HeatMapOptions: {
        type: 'Time',
        time: '24',
        clip: true,
        view: 'Admin',
        serviceType: 'HeatMap'
      }
}

export const TIME_IN_MILLIS_CONST: any = {
    MILLIS_IN_1HOUR: 3600000,
}
